// extracted by mini-css-extract-plugin
export var wordContainer = "_pa-0";